import React, { useEffect, useState } from 'react';
import { Dialog, DialogTitle, DialogContent } from '@mui/material';
import { z } from 'zod';
import { useForm } from 'react-hook-form';
import { IoIosCloseCircle } from "react-icons/io";
import { zodResolver } from '@hookform/resolvers/zod';
import { useMyContext } from '../../../context/MyContext';
import { FaWarehouse } from "react-icons/fa6";
import '../../css/custom-scrollbar.css';
import { Base_Url, getpincode } from '../../../config/config'
import { toast } from 'react-toastify';

import {
    FaIdCard,
    FaAddressCard,
    FaMapMarkerAlt,
    FaUndo,
    FaTimes,
    FaEdit,
    FaSave,
} from 'react-icons/fa';


const schema = z.object({ 
    // orderId: z.string()
    //   .min(1, "Order ID is required")
    //   .regex(/^\d+$/, "Order ID must be numeric"),
    Name: z.string()
        .min(1, "Name is required")
        .regex(/^[a-zA-Z\s]+$/, "Name must only contain alphabetic characters"),

    email: z.string()
        .email("Invalid email address"),
    phone: z.string()
        .length(10, "Phone number must be exactly 10 digits")
        .regex(/^\d+$/, "Phone number must be numeric"),
    contact_person: z.string()
        .min(1, "contact_person is required")
        .regex(/^[a-zA-Z\s]+$/, "contact_person must only contain alphabetic characters"),
    // status: z.string().min(1, "Status is required"),
    date: z.string().min(1, "Add Date is required"),
    address: z.string().min(1, "Address is required"),
    pincode: z.string()
        .length(6, "Pincode must be exactly 6 characters")
        .regex(/^\d+$/, "Pincode must be numeric"),
    city: z.string()
        .min(1, "City is required")
        .regex(/^[A-Za-z\s]+$/, "City must only contain letters and spaces"),
    state: z.string()
        .min(1, "State is required")
        .regex(/^[A-Za-z\s]+$/, "State must only contain letters and spaces"),
    country: z.string()
        .min(1, "Country is required")
        .regex(/^[A-Za-z\s]+$/, "Country must only contain letters and spaces"),
    registerName: z.string()
        .min(1, "Register Name is required")
        .regex(/^[a-zA-Z\s]+$/, "Register Name must only contain alphabetic characters"),
    returnAddress: z.string().optional(),
});


const B2bViewWarehouse = ({ isopen, onClose, warehouse }) => {
    // const token = localStorage.getItem('token');
    // const cusid = localStorage.getItem('cus_id');
    const { isDarkMode } = useMyContext();
    const [isEditMode, setIsEditMode] = useState(false);
    const [isEditId, isSetEditId] = useState(true);
    const [isEditEmail, isSetEditEmail] = useState(true);
    const { register, handleSubmit, formState: { errors }, setValue, reset } = useForm({
        resolver: zodResolver(schema),
    });

    useEffect(() => {
  if (warehouse) {
    reset({
      Id: warehouse.id || '',
      Name: warehouse.name || '',
      email: warehouse.email || '', 
      phone: warehouse.phone_number || '', 
      contact_person: warehouse.contact_person || '',
      date: warehouse.created_at || '', 
      address: warehouse.address || '',
      pincode: warehouse.pin_code || '', 
      city: warehouse.city || '',
      state: warehouse.state || '',
      country: warehouse.country || '',
      registerName: warehouse.name || '',
      returnAddress: warehouse.ret_address || '', 
    });
  } 
}, [warehouse, reset]);

    const onErrors = (errors) => {
        toast.error("Please fix the errors in the form.");
    };

    const handleClose = () => {
        setIsEditMode(false);
        onClose();
    };

    const hanldeAllEditFileds = () => {
        setIsEditMode(!isEditMode);
    }

    const fetchPincodeData = async (pincode) => {
        const token = localStorage.getItem('token');
        const cus_id = localStorage.getItem('cus_id');
        const urlgetPincode = `${Base_Url}${getpincode}?pincode=${pincode}`;
        try {
            const response = await fetch(urlgetPincode, {
                method: 'GET',
                headers: {
                    'token': token,
                    'cus_id': cus_id,
                    'Content-Type': 'application/json'
                }
            }); 
            const data = await response.json();
            if (data && data.status === "SUCCESS") {
                let { city, state } = data.data[0];

                city = city.charAt(0).toUpperCase() + city.slice(1).toLowerCase();
                state = state.charAt(0).toUpperCase() + state.slice(1).toLowerCase();
                setValue("city", city);
                setValue("state", state);
            }
            else if (data && data.message === "Unauthorized access - Invalid token") {
                // toast.error(data.message + " Please login Again");
            }
            else if (data && data.status === "FAIL") {
                toast.error("Something Went Wrong Please Try Again With Another Pincode");
            }
            else {
                toast.error("Failed to fetch city and state data");
            }
        } catch (error) {
            console.error('Error fetching pincode data:', error);
            toast.error("Error fetching pincode data");
        }
    };

    const fetchreturnPincodeData = async (returnPincode) => {
        const token = localStorage.getItem('token');
        const cus_id = localStorage.getItem('cus_id');
        const urlgetPincode = `${Base_Url}${getpincode}?pincode=${returnPincode}`;
        try {
            const response = await fetch(urlgetPincode, {
                method: 'GET',
                headers: {
                    'token': token,
                    'cus_id': cus_id,
                    'Content-Type': 'application/json'
                }
            });
            const data = await response.json();
            if (data && data.status === "SUCCESS") {
                let { city, state } = data.data[0];

                city = city.charAt(0).toUpperCase() + city.slice(1).toLowerCase();
                state = state.charAt(0).toUpperCase() + state.slice(1).toLowerCase();

                setValue("returnCity", city);
                setValue("returnState", state);
            }
            else if (data && data.message === "Unauthorized access - Invalid token") {
                // toast.error(data.message + " Please login Again");
            }

            else if (data && data.status === "FAIL") {
                toast.error("Something Went Wrong Please Try Again With Another Pincode");
            }
            else {
                toast.error("Failed to fetch city and state data");
            }
        } catch (error) {
            console.error('Error fetching pincode data:', error);
            toast.error("Error fetching pincode data");
        }
    };

    const handleInputChange = (event) => {
        const { value, id } = event.target;
        if (['pincode', 'phone', 'return-pincode'].includes(id)) {
            const filteredValue = value.replace(/[^0-9]/g, '');
            event.target.value = filteredValue;
            // Trigger API call if input reaches 6 digits for `return-pincode`
            if (id === 'return-pincode' && filteredValue.length === 6) {
                fetchreturnPincodeData(filteredValue);
            }
            if (id === 'pincode' && filteredValue.length === 6) {
                fetchPincodeData(filteredValue);
            }
        }
        if (['facility-name', 'city', 'contact-person', 'state', 'returnState', 'returnCity', 'returnCountry', 'country'].includes(id)) {
            const filteredValue = value.replace(/[^a-zA-Z\s]/g, '');
            event.target.value = filteredValue;

        }
    };

    return (
        <Dialog
            open={isopen}
            onClose={handleClose}
            maxWidth="md"
            fullWidth
            PaperProps={{
                className: "rounded-lg overflow-hidden rounded-lg"
            }}
        >
            <DialogTitle className="bg-gradient-to-r from-purple-600 to-indigo-700 text-white relative shadow-custom-light dark:shadow-custom-dark -dark">
                <h2 className="text-xs sm:text-xs font-bold text-white font-sans flex items-center">
                    <FaWarehouse className="mr-3" size={16} />
                    Warehouse Details
                </h2>
                <IoIosCloseCircle
                    className="absolute top-3 right-3 cursor-pointer hover:scale-110 transition-transform"
                    size={16}
                    onClick={handleClose}
                />
            </DialogTitle>

            <DialogContent className=" bg-white dark:bg-darkmodeColor dark:text-white custom-scrollbar" style={{ maxHeight: '75vh' }}>
                <div className="p-6 bg-white dark:bg-darkmodeColor dark:text-white shadow-custom-light dark:shadow-custom-dark -dark rounded-custom dark:text-white">
                    <form className="space-y-8 font-sans" >

                        {/* Primary Information Section */}
                        <div className="bg-purple-50 dark:bg-darkmodeColor dark:text-white p-4 rounded-custom border-l-4 border-purple-500">
                            <h3 className="text-lg font-bold mb-4 text-purple-700 dark:text-white flex items-center">
                                <FaIdCard className="mr-2" />
                                Primary Information
                            </h3>

                            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                <div className="bg-white dark:bg-darkmodeColor dark:text-white p-4 rounded-custom dark:shadow-custom-dark -dark shadow-custom-light">
                                    <label className="block text-sm font-bold text-gray-700 dark:text-white mb-2">ID</label>
                                    <input
                                        type="text"
                                        className={`mt-1 p-3 border border-gray-300 w-full rounded-custom focus:ring-2 focus:ring-purple-500 focus:border-purple-500 ${isDarkMode ? " dark:bg-darkmodeColor dark:text-white" : ""}`}
                                        {...register('Id')}
                                        disabled={isEditId}
                                    />
                                    {errors.Id && <p className="text-red-500 text-sm mt-1">{errors.Id.message}</p>}
                                </div>

                                <div className="bg-white dark:bg-darkmodeColor p-4 rounded-custom dark:shadow-custom-dark shadow-cutsom-light ">
                                    <label className="block text-sm font-bold text-gray-700 dark:text-white mb-2">Name</label>
                                    <input
                                        type="text"
                                        id="facility-name"
                                        className={`mt-1 p-3 border border-gray-300 w-full rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-purple-500 ${isDarkMode ? "dark:bg-darkmodeColor dark:text-white" : ""}`}
                                        {...register('Name')}
                                        disabled={!isEditMode}
                                    />
                                    {errors.Name && <p className="text-red-500 text-sm mt-1">{errors.Name.message}</p>}
                                </div>
                            </div>
                        </div>

                        {/* Contact Information Section */}
                        <div className="bg-blue-50 dark:bg-darkmodeColor dark:text-white p-4 rounded-custom border-l-4 border-blue-500">
                            <h3 className="text-lg font-bold mb-4 text-blue-700 dark:text-white flex items-center">
                                <FaAddressCard className="mr-2" />
                                Contact Information
                            </h3>

                            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                <div className="bg-white dark:bg-darkmodeColor dark:text-white p-4 rounded-custom shadow-custom-light dark:shadow-custom-dark -dark">
                                    <label className="block text-sm font-bold text-gray-700 dark:text-white mb-2">Email</label>
                                    <input
                                        type="email"
                                        className={`mt-1 p-3 border border-gray-300 w-full rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-purple-500 ${isDarkMode ? "bg-white dark:bg-darkmodeColor dark:text-white" : ""}`}
                                        {...register('email')}
                                        disabled={isEditEmail}
                                    />
                                    {errors.email && <p className="text-red-500 text-sm mt-1">{errors.email.message}</p>}
                                </div>

                                <div className="bg-white dark:bg-darkmodeColor dark:text-white p-4 rounded-custom shadow-custom-light dark:shadow-custom-dark">
                                    <label className="block text-sm font-bold text-gray-700 dark:text-white mb-2">contact person</label>
                                    <input
                                        type="text"
                                        className={`mt-1 p-3 border border-gray-300 w-full rounded-custom focus:ring-2 focus:ring-purple-500 focus:border-purple-500 ${isDarkMode ? "bg-white dark:bg-darkmodeColor dark:text-white" : ""}`}
                                        {...register('contact_person')}
                                        disabled={!isEditMode}
                                    />
                                    {errors.contact_person && <p className="text-red-500 text-sm mt-1">{errors.contact_person.message}</p>}
                                </div>
                            </div>

                            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-4">
                                <div className="bg-white dark:bg-darkmodeColor dark:text-white p-4 rounded-custom shadow-custom-light dark:shadow-custom-dark">
                                    <label className="block text-sm font-bold text-gray-700 dark:text-white mb-2">Phone</label>
                                    <input
                                        type="tel"
                                        id="phone"
                                        className={`mt-1 p-3 border border-gray-300 w-full rounded-custom focus:ring-2 focus:ring-purple-500 focus:border-purple-500 ${isDarkMode ? "bg-white dark:bg-darkmodeColor dark:text-white" : ""}`}
                                        {...register('phone')}
                                        maxLength={10}
                                        disabled={!isEditMode}
                                    />
                                    {errors.phone && <p className="text-red-500 text-sm mt-1">{errors.phone.message}</p>}
                                </div>
                                <div className="bg-white dark:bg-darkmodeColor dark:text-white p-4 rounded-custom shadow-custom-light dark:shadow-custom-dark -dark">
                                    <label className="block text-sm font-bold text-gray-700 dark:text-gray-300 mb-2">Add Date</label>
                                    <input
                                        type="text"
                                        className={`mt-1 p-3 border border-gray-300 w-full rounded-custom focus:ring-2 focus:ring-purple-500 focus:border-purple-500 ${isDarkMode ? "bg-white dark:bg-darkmodeColor dark:text-white" : ""}`}
                                        {...register('date')}
                                        disabled={!isEditMode}
                                    />
                                    {errors.date && <p className="text-red-500 text-sm mt-1">{errors.date.message}</p>}
                                </div>
                            </div>
                        </div>

                        {/* Address Information Section */}
                        <div className="bg-green-50 dark:bg-darkmodeColor p-4 rounded-custom border-l-4 border-green-500">
                            <h3 className="text-lg font-bold mb-4 text-green-700 dark:text-green-300 flex items-center">
                                <FaMapMarkerAlt className="mr-2" />
                                Address Information
                            </h3>

                            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                <div className="bg-white dark:bg-darkmodeColor dark:text-white  p-4 rounded-custom shadow-custom-light dark:shadow-custom-dark -dark">
                                    <label className="block text-sm font-bold text-gray-700 dark:text-white mb-2">Address</label>
                                    <input
                                        type="text"
                                        id="address"
                                        className={`mt-1 p-3 border border-gray-300 w-full rounded-custom focus:ring-2 focus:ring-purple-500 focus:border-purple-500 ${isDarkMode ? "bg-white dark:bg-darkmodeColor dark:text-white" : ""}`}
                                        {...register('address')}
                                        disabled={!isEditMode}
                                    />
                                    {errors.address && <p className="text-red-500 text-sm mt-1">{errors.address.message}</p>}
                                </div>

                                <div className="bg-white dark:bg-darkmodeColor dark:text-white  p-4 rounded-custom shadow-custom-light dark:shadow-custom-dark -dark">
                                    <label className="block text-sm font-bold text-gray-700 dark:text-white mb-2">Pincode</label>
                                    <input
                                        type="text"
                                        id="pincode"
                                        className={`mt-1 p-3 border border-gray-300 w-full rounded-custom focus:ring-2 focus:ring-purple-500 focus:border-purple-500 ${isDarkMode ? "bg-white dark:bg-darkmodeColor dark:text-whitse" : ""}`}
                                        {...register('pincode')}
                                        onChange={handleInputChange}
                                        maxLength={6}
                                        disabled={!isEditMode}
                                    />
                                    {errors.pincode && <p className="text-red-500 text-sm mt-1">{errors.pincode.message}</p>}
                                </div>
                            </div>

                            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-4">
                                <div className="bg-white dark:bg-darkmodeColor dark:text-white p-4 rounded-custom dark:shadow-custom-dark  shadow-custom-light">
                                    <label className="block text-sm font-bold text-gray-700 dark:text-white mb-2">City</label>
                                    <input
                                        type="text"
                                        id="city"
                                        className={`mt-1 p-3 border border-gray-300 w-full rounded-custom focus:ring-2 focus:ring-purple-500 focus:border-purple-500 ${isDarkMode ? "bg-white dark:bg-darkmodeColor dark:text-white " : ""}`}
                                        {...register('city')}
                                        disabled={!isEditMode}
                                    />
                                    {errors.city && <p className="text-red-500 text-sm mt-1">{errors.city.message}</p>}
                                </div>

                                <div className="bg-white dark:bg-darkmodeColor dark:text-white p-4 rounded-custom dark:shadow-custom-dark  shadow-custom-light">
                                    <label className="block text-sm font-bold text-gray-700 dark:text-white mb-2">State</label>
                                    <input
                                        type="text"
                                        id="state"
                                        className={`mt-1 p-3 border border-gray-300 w-full rounded-custom focus:ring-2 focus:ring-purple-500 focus:border-purple-500 ${isDarkMode ? "bg-white dark:bg-darkmodeColor dark:text-white" : ""}`}
                                        {...register('state')}
                                        disabled={!isEditMode}
                                    />
                                    {errors.state && <p className="text-red-500 text-sm mt-1">{errors.state.message}</p>}
                                </div>
                            </div>

                            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-4">
                                <div className="bg-white dark:bg-darkmodeColor dark:text-white p-4 rounded-custom dark:shadow-custom-dark -dark shadow-custom-light">
                                    <label className="block text-sm font-bold text-gray-700 dark:text-white mb-2">Country</label>
                                    <input
                                        type="text"
                                        id='country'
                                        className={`mt-1 p-3 border border-gray-300 w-full rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-purple-500 ${isDarkMode ? "bg-white dark:bg-darkmodeColor dark:text-white" : ""}`}
                                        {...register('country')}
                                        disabled={!isEditMode}
                                    />
                                    {errors.country && <p className="text-red-500 text-sm mt-1">{errors.country.message}</p>}
                                </div>

                                <div className="bg-white dark:bg-darkmodeColor dark:text-white p-4 rounded-custom dark:shadow-custom-dark -dark  shadow-custom-light">
                                    <label className="block text-sm font-bold text-gray-700 dark:text-white mb-2">Register Name</label>
                                    <input
                                        type="text"
                                        className={`mt-1 p-3 border border-gray-300 w-full rounded-custom focus:ring-2 focus:ring-purple-500 focus:border-purple-500 ${isDarkMode ? "bg-white dark:bg-darkmodeColor dark:text-white" : ""}`}
                                        {...register('registerName')}
                                        disabled={!isEditMode}
                                    />
                                    {errors.registerName && <p className="text-red-500 text-sm mt-1">{errors.registerName.message}</p>}
                                </div>
                            </div>
                        </div>

                        {/* Return Address Section */}
                        <div className="bg-yellow-50 dark:bg-darkmodeColor p-4 rounded-custom border-l-4 border-yellow-500">
                            <h3 className="text-lg font-bold mb-4 text-yellow-700 dark:text-yellow-300 flex items-center">
                                <FaUndo className="mr-2" />
                                Return Address Details
                            </h3>
                            <div className="bg-white dark:bg-darkmodeColor dark:text-white p-4 rounded-cutsom dark:shadow-custom-dark  shadow-custom-light">
                                <label className="block text-sm font-bold text-gray-700 dark:text-white mb-2">Return Address</label>
                                <input
                                    type="text"
                                    id="returnAddress"
                                    className={`mt-1 p-3 border border-gray-300 w-full rounded-custom focus:ring-2 focus:ring-purple-500 focus:border-purple-500 ${isDarkMode ? "bg-white dark:bg-darkmodeColor dark:text-white" : ""}`}
                                    {...register('returnAddress')}
                                    disabled={!isEditMode}
                                />
                                {errors.returnAddress && <p className="text-red-500 text-sm mt-1">{errors.returnAddress.message}</p>}
                            </div>
                        </div>
                        {/* Action Buttons */}
                        <div className="flex space-x-4 mt-8">
                            <button
                                type="button"
                                onClick={hanldeAllEditFileds}
                                className="bg-gradient-to-r from-purple-600 to-indigo-700 text-white py-3 px-6 rounded-custom hover:from-purple-700 hover:to-indigo-800 focus:outline-none focus:ring-2 focus:ring-purple-500 focus:ring-opacity-50 font-medium transition-colors flex items-center dark:shadow-custom-dark  shadow-custom-light"
                            >
                                {isEditMode ? (
                                    <>
                                        <FaTimes className="mr-2" /> Cancel Editing
                                    </>
                                ) : (
                                    <>
                                        <FaEdit className="mr-2" /> Edit Warehouse
                                    </>
                                )}
                            </button>

                            {(isEditMode && isEditId && isEditEmail) && (
                                <button
                                    type="submit"
                                    className="bg-gradient-to-r from-green-500 to-green-600 text-white py-3 px-6 rounded-custom hover:from-green-600 hover:to-green-700 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-opacity-50 font-medium transition-colors flex items-center dark:shadow-custom-dark  shadow-custom-light"
                                >
                                    <FaSave className="mr-2" /> Save Changes
                                </button>
                            )}
                        </div>
                    </form>
                </div>
            </DialogContent>
        </Dialog>
    );
};


export default B2bViewWarehouse;
